import CryptoJS from 'crypto-js';

export function decryptData(encryptedData) {
  if (encryptedData !== null) {
    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken || accessToken.length < 32) {
        localStorage.clear(); // Clear all localStorage
        return null;
      }

      const keyBase64 = accessToken.substring(0, 32); // Use 32 characters for key
      const key = CryptoJS.enc.Base64.parse(keyBase64);

      let decodedData; // Declare decodedData outside try block
      try {
        decodedData = JSON.parse(atob(encryptedData));
        if (!decodedData.iv || !decodedData.value) {
          throw new Error("Invalid encrypted data.");
        }
      } catch (e) {
        // If atob() fails or JSON.parse fails, clear localStorage and return null
        localStorage.clear();
        return null;
      }

      const iv = CryptoJS.enc.Base64.parse(decodedData.iv);
      const encrypted = decodedData.value;

      const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      const originalText = decrypted.toString(CryptoJS.enc.Utf8);
      if (!originalText) {
        throw new Error("Failed to decrypt data: invalid UTF-8 encoding.");
      }

      return originalText;
    } catch (error) {
      console.error("Decryption error:", error);
      localStorage.clear(); // Clear all localStorage on any error
      return null;
    }
  } else {
    return null;
  }
}

export function getUserDataDecrypted() {
  const userDataEncrypted = localStorage.getItem("userData");
  const userDataDecrypted = decryptData(userDataEncrypted);

  return userDataDecrypted;
}




